export function formatDate(dateString: string): string[] {
    const date = new Date(dateString);
    const formattedDate = new Intl.DateTimeFormat('nl-NL', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(date);
    const weekday = new Intl.DateTimeFormat('nl-NL', {
        weekday: 'short',
    }).format(date);

    return [weekday.replace(/^./, weekday[0].toUpperCase()), formattedDate];
}
